// @material-ui/core
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { AccountCircle, MoreVert as MoreIcon } from "@material-ui/icons";
import LogoutIcon from "mdi-react/LogoutIcon";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";

const styles = theme => ({
  menuButton: {
    marginLeft: 2,
    marginRight: 2,
    color: "white"
  },
  hide: {
    display: "none"
  },
  flex: {
    flex: 1,
    textTransform: "capitalize"
  },
  title: {
    marginRight: "5px",
    marginLeft: "10px"
  },
  menuItem: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& $primary, & $icon": {
        color: theme.palette.common.white
      },
      outline: "none"
    }
  },
  primary: {},
  icon: {
    color: theme.palette.text.secondary,
    fill: theme.palette.text.secondary
  },
  noOutline: {
    "&:focus": {
      outline: "none"
    }
  }
});

class MainBarMenu extends Component {
  state = {
    anchorEl: null
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;

    const open = Boolean(anchorEl);

    return (
      <React.Fragment>
        <IconButton
          aria-owns={open ? "menu-appbar" : null}
          aria-haspopup="true"
          onClick={this.handleMenu}
          color="inherit">
          <MoreIcon />
        </IconButton>

        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={open}
          onClose={this.handleClose}
          classes={{ paper: classes.menu }}>
          <Link to="/profile" className={classes.noOutline}>
            <MenuItem className={classes.menuItem} onClick={this.handleClose}>
              <ListItemIcon className={classes.icon}>
                <AccountCircle />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.primary }}
                inset
                primary="Profile"
              />
            </MenuItem>
          </Link>
          <Link to="/logout" className={classes.noOutline}>
            <MenuItem className={classes.menuItem} onClick={this.handleClose}>
              <ListItemIcon className={classes.icon}>
                <LogoutIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.primary }}
                inset
                primary="Sign out"
              />
            </MenuItem>
          </Link>
        </Menu>
      </React.Fragment>
    );
  }
}

MainBarMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(MainBarMenu);



// WEBPACK FOOTER //
// ./src/appBar/MainBarMenu.js